import { render, staticRenderFns } from "./ActionMenuItem.vue?vue&type=template&id=e5410c08"
import script from "./ActionMenuItem.vue?vue&type=script&lang=js"
export * from "./ActionMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports